//src/pages/PrivacySettings.jsx
import React,{useEffect,useState} from "react";
import api from "../api";
import "../theme/design.css";

export default function PrivacySettings(){

const [isPrivate,setIsPrivate] = useState(false);
const [messagePrivacy,setMessagePrivacy] = useState("everyone");
const [showActivity,setShowActivity] = useState(true);

useEffect(()=>{

load();

},[]);

const load = async()=>{

try{

const {data} = await api.get("/account/privacy");

setIsPrivate(!!data.is_private);
setMessagePrivacy(data.message_privacy || "everyone");
setShowActivity(data.show_activity ?? true);

}catch(e){
console.log(e);
}

};

const update = async(values)=>{

try{

await api.post("/account/privacy",values);

}catch{
alert("Failed to update");
}

};

return(

<div className="page">

<div className="post-card">

<h2 style={{marginBottom:20}}>Privacy</h2>

{/* PRIVATE ACCOUNT */}

<div style={{marginBottom:20}}>

<label style={{display:"flex",justifyContent:"space-between"}}>

<div>
<strong>Private account</strong>
<div style={{fontSize:13,color:"#9ca3af"}}>
Only followers can see your posts
</div>
</div>

<input
type="checkbox"
checked={isPrivate}
onChange={(e)=>{

const v = e.target.checked;

setIsPrivate(v);

update({is_private:v});

}}
/>

</label>

</div>

{/* MESSAGE PRIVACY */}

<div style={{marginBottom:20}}>

<strong>Messages</strong>

<div style={{marginTop:8}}>

<select
value={messagePrivacy}
onChange={(e)=>{

const v = e.target.value;

setMessagePrivacy(v);

update({message_privacy:v});

}}
>

<option value="everyone">Everyone</option>
<option value="followers">Followers only</option>
<option value="none">Nobody</option>

</select>

</div>

</div>

{/* ACTIVITY STATUS */}

<div>

<label style={{display:"flex",justifyContent:"space-between"}}>

<div>
<strong>Show activity status</strong>
<div style={{fontSize:13,color:"#9ca3af"}}>
Allow others to see when you are online
</div>
</div>

<input
type="checkbox"
checked={showActivity}
onChange={(e)=>{

const v = e.target.checked;

setShowActivity(v);

update({show_activity:v});

}}
/>

</label>

</div>

</div>

</div>

);

}